/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import DatePicker from "react-datepicker";
import { Button, Modal, ModalBody } from "reactstrap";
import moment from "moment";

import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import styled from "styled-components";
import { useDebouncedCallback } from "use-debounce";
import modulos from "../../../mocks/modulos";
import { useAuth } from "../../../context/AuthContext";
import useFetcher from "../../../hooks/useFetcher";
import { fetchRegiones } from "../../../services/regionServices";
import { fetchSucursales } from "../../../services/sucursalServices";
import { handleErrors } from "../../../services/handleErrors";
import { fetchPiAsignable } from "../../../services/ticketingServices";
import { fetchClientesPaginados } from "../../../services/clientesServices";
import { retriveRegionSucursalOptions } from "../../../utils/retriveRegionSucursalOptions";
import { getNotasDePedidoBySubclientId, getNotasDePedidoCategory, postNotaDePedidoV2 } from "../../../services/notasDePedidoServices";
import { ButtonPrimary } from "../../../ui/buttons";
import { LabSelect } from "../../../components/course/select";
import { CustomLabel } from "../../../ui/labels";
import { InputCheckboxContainer, InputText } from "../../../ui/inputs";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { formatearFecha } from "../../../components/CandidatosNP/utils";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import { TemplateHeader } from "../../../components/RelevosInfoGeneral/styles";
import { fetchCompanias } from "../../../services/companiaServices";
import { fetchServicios } from "../../../services/servicioServices";
import { fetchSubclientsPaginados } from "../../../services/subclientesServices";
import { AsyncLabSelect } from "../../../components/AsyncLabSelect";

const GridGroup = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 10px;
  margin: 5px 0;
`;

const promiseOptions = (inputValue, preParams) =>
  new Promise((resolve) => {
    setTimeout(async () => {
      const params = {
        ...preParams,
        razonSocial: inputValue,
      };

      try {
        const response = await fetchClientesPaginados(params);
        const { result } = response;

        const clientes = result.rows || {};
        const options =
          clientes && clientes.length > 0
            ? clientes.map((cliente) => ({
                label: cliente.razonSocial,
                value: cliente.razonSocial,
                cuit: cliente.cuit,
                id: cliente.id,
              }))
            : [];

        resolve(options);
      } catch (error) {
        resolve([]);
      }
    }, 500);
  });

const FormNuevaNP = ({ history, toggle, reloadNotas }) => {
  const { currentUser, haveSucursalesAccess } = useAuth();
  const { user } = currentUser;
  const isAdmin = currentUser.haveAdminAccess(modulos.NOTAS_DE_PEDIDO);
  const fechaActual = moment().format("YYYY-MM-DD");
  const locale = configDatePickerLenguage();
  const [subclientId, setSubclientId] = useState(null);
  const [category, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [piAsignable, isLoadingPiAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [clientsParams, setClientsParams] = useState({ page: 1, perpage: 50 });
  const [clientesDefault, isLoadingClientes] = useFetcher(fetchClientesPaginados, [clientsParams]);
  const [subClientsParams, setSubClientsParams] = useState({ page: 1, perpage: 100 });
  const [subclients, isLoadingSubclients] = useFetcher(fetchSubclientsPaginados, [subClientsParams]);
  const [notasDePedido, isLoadingNotasDePedido] = useFetcher(getNotasDePedidoBySubclientId, [subclientId]);

  const [areaValue, setAreaValue] = useState(null);
  const [posicionesValue, setPosicionesValue] = useState(null);
  const [razonSocialValue, setRazonSocialValue] = useState(null);
  const [subclienteValue, setSubclienteValue] = useState(null);
  const [fechaAbiertaValue, setFechaAbiertaValue] = useState(fechaActual);
  const [fechaPreventivaValue, setFechaPreventivaValue] = useState(fechaActual);
  const [recruiterValue, setRecruiterValue] = useState({ label: user.Pi.nombreApellido, value: user.Pi.itemId });
  const [region, setRegion] = useState(null);
  const [sucursal, setSucursal] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [empresaAdeccoValue, setEmpresaAdeccoValue] = useState(null);
  const [servicioValue, setServicioValue] = useState(null);
  const [cotizacionValue, setCotizacionValue] = useState(null);
  const [legajoValue, setLegajoValue] = useState(null);
  const [servicioSubservicioIdValue, setServicioSubservicioIdValue] = useState(null);
  const [changeRazonSocial, setChangeRazonSocial] = useState(false);
  const [preventiva, setPreventiva] = useState(false);

  const loadOptions = useDebouncedCallback((inputValue, callback) => {
    promiseOptions(inputValue, clientsParams).then(callback);
  }, 500);

  // se eliminan las sucursales y regiones que estan Inactivas
  const sucursalesActivas = sucursales.filter((s) => s.estado !== 2);
  const regionesActivas = regiones.filter((r) => r.estado !== 2);

  // solo se muestran las sucursales asignadas para el usuario member (activas)
  const sucursalesAsignadas = currentUser.user && currentUser.user.sucursalesAsignadas.map((s) => s.itemId);
  const filteredSucursales = sucursalesActivas.filter((s) => sucursalesAsignadas.includes(s.itemId));

  // se elimina la region CASA CENTRAL por defecto de las regiones
  const regionesFiltered = regionesActivas.filter((r) => r.title !== "CASA CENTRAL");

  // se pasa un array vacio para eliminar del select las sucursales de casa central
  const casasCentralesVacio = [];

  const helperRegionSucursal = retriveRegionSucursalOptions(
    region,
    sucursal,
    regionesFiltered,
    isAdmin ? sucursalesActivas : filteredSucursales,
    casasCentralesVacio,
    isLoadingRegiones || isLoadingSucursales,
    haveSucursalesAccess(modulos.NOTAS_DE_PEDIDO),
    currentUser.user
  );

  let recruiterFilteres = piAsignable;
  if (helperRegionSucursal.selectedRegion || helperRegionSucursal.selectedSucursal) {
    recruiterFilteres = piAsignable.filter((pi) => {
      const sucursalesPi = (pi.CasaCentral || []).concat(pi.SucursalesAsignadas || []);
      return (
        (!helperRegionSucursal.selectedRegion || sucursalesPi.map((suc) => suc.region2).includes(helperRegionSucursal.selectedRegion)) &&
        (!helperRegionSucursal.selectedSucursal || sucursalesPi.map((suc) => suc.itemId).includes(helperRegionSucursal.selectedSucursal))
      );
    });
  }

  // filtra por Pis con puesto RECRUITER, CONSULTANT, ONSITE y ONSITE C para mostrarlos en el select
  recruiterFilteres = recruiterFilteres.filter(
    (pi) =>
      (pi.posicionCat && pi.posicionCat.text === "RECRUITER") ||
      (pi.posicionCat && pi.posicionCat.text === "CONSULTANT") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE C")
  );

  const recruiterOptions = recruiterFilteres
    ? recruiterFilteres
        .map((e) => {
          return { label: e.nombreApellido, value: e.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const clientesDefaultOptions = clientesDefault.rows
    ? clientesDefault.rows
        .map((e) => {
          return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const subClientesOptions =
    subclients && subclients.rows && subclients.rows.length > 0
      ? subclients.rows
          .map((e) => {
            const numeroLegajo = e.numeroDeLegajo.split(".")[0];
            return { label: numeroLegajo, value: e.itemId, legajo: e.numeroDeLegajo };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  // si el cliente no tiene cuit, se muestra un error y no permite crear la NP
  useEffect(() => {
    if (razonSocialValue && !razonSocialValue.cuit) {
      toast.error("El cliente debe tener un CUIT para poder asignarle una nota de pedido");
      setRazonSocialValue(null);
    }
    if (razonSocialValue && razonSocialValue.id) {
      setSubClientsParams({ ...subClientsParams, clientId: razonSocialValue.id });
    }
  }, [razonSocialValue]);

  const posicionesOptions =
    notasDePedido && notasDePedido.rows
      ? notasDePedido.rows
          .map((e) => {
            return { label: e.posicion, value: e.posicion };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  function getFunctionToFilter(filter, selected) {
    if (filter === "posicion") {
      setPosicionesValue(selected);
    }
    if (filter === "recruiter") {
      setRecruiterValue(selected);
    }
    if (filter === "razonSocial") {
      setRazonSocialValue(selected);
      setChangeRazonSocial(true);
    }
    if (filter === "subCliente") {
      setSubclienteValue(selected);
    }
    if (filter === "region") {
      try {
        setRegion(selected.value);
        setClientsParams({ ...clientsParams, region: JSON.stringify(selected.value) });
        setSubClientsParams({ ...subClientsParams, region: JSON.stringify(selected.value) });
      } catch (error) {
        setRegion("");
      }
    }
    if (filter === "sucursalId") {
      try {
        setSucursal(selected.value);
        setClientsParams({ ...clientsParams, sucursal: JSON.stringify(selected.value) });
        setSubClientsParams({ ...subClientsParams, sucursal: JSON.stringify(selected.value) });
      } catch (error) {
        setSucursal("");
      }
    }
  }

  useEffect(() => {
    if (helperRegionSucursal.selectedRegion || helperRegionSucursal.selectedSucursal) {
      setRegion(helperRegionSucursal.selectedRegion);
      setSucursal(helperRegionSucursal.selectedSucursal);
    }
  }, [helperRegionSucursal]);

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaAbiertaValue(fechaFormateada);
  };

  const handlePreventiveDateChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaPreventivaValue(fechaFormateada);
  };

  const handleRedirect = (id) => {
    history.push({
      pathname: `/notasDePedido/${id}/detail`,
    });
  };

  const inputError = () => {
    const error = { error: false };

    if (posicionesValue === null) {
      error.posicion = "Debe seleccionar una posición.";
      error.error = true;
    } else if (posicionesValue.value === "" || posicionesValue.value === undefined) {
      error.posiciones = "Debe seleccionar una posición.";
      error.error = true;
    }

    if (sucursal === null) {
      error.sucursalId = "Debe seleccionar una sucursal.";
      error.error = true;
    } else if (sucursal === "" || sucursal === undefined || isNaN(sucursal)) {
      error.sucursalId = "Debe seleccionar una sucursal.";
      error.error = true;
    }

    if (recruiterValue === null) {
      error.recruiter = "Debe seleccionar un recruiter.";
      error.error = true;
    } else if (recruiterValue.value === "" || recruiterValue.value === undefined) {
      error.recruiter = "Debe seleccionar un recruiter.";
      error.error = true;
    }

    if (razonSocialValue === null) {
      error.cliente = "Debe seleccionar un cliente.";
      error.error = true;
    } else if (razonSocialValue.value === "" || razonSocialValue.value === undefined) {
      error.cliente = "Debe seleccionar un cliente.";
      error.error = true;
    }

    if (fechaAbiertaValue === "" || fechaAbiertaValue === undefined) {
      error.fechaAbierta = "Debe seleccionar una fecha";
    }

    return error;
  };

  const messageError = inputError();

  const formik = useFormik({
    initialValues: {
      estado: "",
      codigoDeAreaId: "",
      posicion: "",
      vacantes: "",
      cargo: "",
      sucursalId: "",
      region,
      servicio: "",
      recruiter: "",
      razonSocial: "",
      subClienteId: "",
      legajo: "",
      cuit: "",
      fechaAbierta: "",
      cotizacionNPId: "",
      empresaAdecco: "",
      fechaObjetivoCobertura: null,
    },
    onSubmit: async (values) => {
      if (messageError.error) return;

      if (!servicioValue || !servicioValue.value) {
        toast.error("La nota debe tener un servicio asignado");
        return;
      }
      if (!empresaAdeccoValue || !empresaAdeccoValue.value) {
        toast.error("La nota debe tener una empresa de Adecco asignada");
        return;
      }
      if (!areaValue || !areaValue.value) {
        toast.error("La nota debe tener un área asignada");
        return;
      }
      if (!cotizacionValue || !cotizacionValue.value) {
        toast.error("La nota debe tener una cotización");
        return;
      }
      if (!legajoValue) {
        toast.error("La nota debe tener un legajo de subcliente asignado");
        return;
      }

      try {
        const notaDePedidoToPost = {
          ...values,
          region,
          sucursalId: sucursal,
          estado: preventiva ? 12 : 1,
          codigoDeAreaId: areaValue && areaValue.value,
          posicion: posicionesValue && posicionesValue.value,
          fechaAbierta: preventiva ? null : fechaAbiertaValue,
          fechaPreventiva: preventiva ? fechaPreventivaValue : null,
          recruiter: recruiterValue.value,
          razonSocial: razonSocialValue.value,
          subClienteId: subclientId,
          legajo: legajoValue || "",
          servicioSubservicioId: servicioSubservicioIdValue || "",
          cuit: razonSocialValue.cuit || "",
          empresaAdecco: empresaAdeccoValue.value,
          servicio: servicioValue.value,
          cotizacionNPId: cotizacionValue.value,
        };

        const { message, result } = await postNotaDePedidoV2(notaDePedidoToPost);
        toast.success(message);
        await Timeout.set(1000);
        if (result && result.id) {
          handleRedirect(result.id);
        } else {
          reloadNotas();
          toggle();
        }
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },

    validationSchema: Yup.object().shape({
      cargo: Yup.string().required("Este campo es requerido."),
      vacantes: Yup.number()
        .required("Este campo es requerido.")
        .min(1, "El número de vacantes debe ser 1 o más.")
        .integer("El número de vacantes debe ser un número entero."),
    }),
  });

  const handleCancelarNota = () => {
    formik.resetForm();
    setConfirmModal(false);
    toggle();
  };

  useEffect(() => {
    if (posicionesValue && posicionesValue.value && notasDePedido && notasDePedido.rows && !isLoadingCategoies && !isLoadingCompanias && !isLoadingServicios) {
      const currentNotaDePedido = notasDePedido.rows.find((np) => np.posicion === posicionesValue.value);
      if (currentNotaDePedido) {
        const area = (category && category.areas.find((a) => a.id === currentNotaDePedido.codigoDeAreaId)) || "sin area";
        setAreaValue(area ? { value: currentNotaDePedido.codigoDeAreaId, label: area.nombre } : null);

        const empresaAdeccoId = currentNotaDePedido.empresaAdecco === 4 ? 3 : currentNotaDePedido.empresaAdecco;
        const compania = companias.find((c) => c.id === empresaAdeccoId);
        setEmpresaAdeccoValue(compania ? { value: currentNotaDePedido.empresaAdecco, label: compania.text } : null);

        const servicio = servicios.find((s) => s.id === currentNotaDePedido.servicio);
        setServicioValue(servicio ? { value: currentNotaDePedido.servicio, label: servicio.text } : null);
        const cotizacion = currentNotaDePedido && currentNotaDePedido.cotizacionNP;
        setCotizacionValue(cotizacion ? { value: cotizacion.id, label: cotizacion.idCotizacion } : null);
        const legajo = currentNotaDePedido.subClienteLegajo;
        setLegajoValue(legajo || null);
        const servicioSubservicioId = currentNotaDePedido && currentNotaDePedido.servicioSubservicioId;
        setServicioSubservicioIdValue(servicioSubservicioId || null);
      }
    }
  }, [posicionesValue, isLoadingCategoies, isLoadingCompanias, isLoadingServicios, notasDePedido]);

  useEffect(() => {
    const updateParams = (params, key) => {
      const newParams = { ...params };
      if (newParams[key] !== undefined) {
        delete newParams[key];
      }
      return newParams;
    };

    if (!region) {
      setClientsParams((prevParams) => updateParams(prevParams, "region"));
      setSubClientsParams((prevParams) => updateParams(prevParams, "region"));
    }
    if (!sucursal) {
      setClientsParams((prevParams) => updateParams(prevParams, "sucursal"));
      setSubClientsParams((prevParams) => updateParams(prevParams, "sucursal"));
    }
    setRazonSocialValue(null);
    setChangeRazonSocial(true);
  }, [region, sucursal]);

  useEffect(() => {
    if (changeRazonSocial) {
      setPosicionesValue(null);
      setSubclienteValue(null);
      setServicioValue(null);
      setEmpresaAdeccoValue(null);
      setAreaValue(null);
      setCotizacionValue(null);
      setChangeRazonSocial(false);
    }
  }, [changeRazonSocial]);

  useEffect(() => {
    if (subclienteValue && subclienteValue.value) {
      setSubclientId(subclienteValue.value);
      setPosicionesValue(null);
      setServicioValue(null);
      setEmpresaAdeccoValue(null);
      setAreaValue(null);
      setCotizacionValue(null);
    }
  }, [subclienteValue]);

  return (
    <>
      <form style={{ width: "80%" }} onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <GridGroup>
            <div>
              <CustomLabel htmlFor="region" className="col-form-label pt-0 w-100">
                Region
                <LabSelect
                  id="region"
                  name="region"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={
                    helperRegionSucursal.regionesOptions.length === 1
                      ? helperRegionSucursal.regionesOptions
                      : helperRegionSucursal.regionesOptions.find((option) => {
                          return option.value === helperRegionSucursal.selectedRegion;
                        }) || null
                  }
                  placeholder="Seleccionar.."
                  isClearable
                  isLoading={isLoadingRegiones}
                  isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal || helperRegionSucursal.regionesOptions.length === 1}
                  options={helperRegionSucursal.regionesOptions}
                />
              </CustomLabel>
            </div>
            <div>
              <CustomLabel htmlFor="sucursalId" className="col-form-label pt-0 w-100">
                Sucursal
                <LabSelect
                  id="sucursalId"
                  name="sucursalId"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={helperRegionSucursal.casasAndSucusOptions.filter((option) => (sucursal ? JSON.stringify(sucursal).includes(option.value) : "")) || null}
                  placeholder="Seleccionar.."
                  isClearable
                  isLoading={isLoadingSucursales || isLoadingRegiones}
                  isDisabled={isLoadingSucursales || helperRegionSucursal.disableRegionSucursal}
                  options={helperRegionSucursal.casasAndSucusOptions}
                />
              </CustomLabel>
              {messageError.sucursalId && formik.touched.sucursalId && (
                <CustomLabel style={{ color: "red" }} className="input-feedback">
                  {messageError.sucursalId}
                </CustomLabel>
              )}
            </div>
          </GridGroup>
          <TemplateHeader className="mb-3" />
          <GridGroup>
            <div>
              <div className="mb-3">
                <CustomLabel htmlFor="razonSocial" className="col-form-label pt-0 w-100">
                  Cliente
                  <AsyncLabSelect
                    id="razonSocial"
                    name="razonSocial"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={razonSocialValue}
                    placeholder="Seleccionar..."
                    isClearable
                    loadOptions={loadOptions}
                    defaultOptions={clientesDefaultOptions}
                    isLoading={isLoadingClientes}
                  />
                </CustomLabel>
                {(formik.errors.razonSocial || messageError.cliente) && formik.touched.razonSocial && (
                  <CustomLabel style={{ color: "red" }} className="input-feedback">
                    {formik.errors.razonSocial || messageError.cliente}
                  </CustomLabel>
                )}
              </div>
            </div>
            <div>
              <div className="mb-3">
                <CustomLabel htmlFor="subCliente" className="col-form-label pt-0 w-100">
                  Sub Cliente
                  <LabSelect
                    id="subCliente"
                    name="subCliente"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={subclienteValue}
                    placeholder="Seleccionar.."
                    isClearable
                    isLoading={isLoadingSubclients}
                    isDisabled={isLoadingSubclients || !razonSocialValue || (subClientesOptions && subClientesOptions.length === 0)}
                    options={subClientesOptions}
                  />
                </CustomLabel>
                {formik.errors.subCliente && formik.touched.subCliente && (
                  <CustomLabel style={{ color: "red" }} className="input-feedback">
                    {formik.errors.subCliente}
                  </CustomLabel>
                )}
              </div>
            </div>

            <div>
              <CustomLabel htmlFor="posicion" className="col-form-label pt-0 w-100">
                Posición
                <LabSelect
                  id="posicion"
                  name="posicion"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={posicionesValue}
                  placeholder="Seleccionar.."
                  isClearable
                  isLoading={isLoadingNotasDePedido}
                  isDisabled={isLoadingNotasDePedido || !subclienteValue || (posicionesOptions && posicionesOptions.length === 0)}
                  options={posicionesOptions}
                />
              </CustomLabel>
              {messageError.posicion && formik.touched.posicion && (
                <CustomLabel style={{ color: "red" }} className="input-feedback">
                  {messageError.posicion}
                </CustomLabel>
              )}
            </div>
            <div>
              <CustomLabel htmlFor="recruiter" className="col-form-label pt-0 w-100">
                Recruiter
                <LabSelect
                  id="recruiter"
                  name="recruiter"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={recruiterValue}
                  placeholder="Seleccionar.."
                  isClearable
                  isLoading={isLoadingPiAsignable}
                  isDisabled={isLoadingPiAsignable}
                  options={recruiterOptions}
                />
              </CustomLabel>
              {messageError.recruiter && formik.touched.recruiter && (
                <CustomLabel style={{ color: "red" }} className="input-feedback">
                  {messageError.recruiter}
                </CustomLabel>
              )}
            </div>
          </GridGroup>

          <GridGroup>
            <div>
              <CustomLabel htmlFor="cotizacionNPId" className="col-form-label pt-0 w-100">
                Cotización
                <InputText
                  className="w-100"
                  type="text"
                  name="cotizacionNPId"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={(cotizacionValue && cotizacionValue.label) || "Sin cotización"}
                  style={{ borderBottom: formik.errors.cotizacionNPId && formik.touched.cotizacionNPId ? "1px solid red" : null }}
                />
              </CustomLabel>
            </div>
            <div>
              <CustomLabel htmlFor="servicio" className="col-form-label pt-0 w-100">
                Servicio
                <InputText
                  className="w-100"
                  type="text"
                  name="servicio"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={(servicioValue && servicioValue.label) || "Sin servicio"}
                  style={{ borderBottom: formik.errors.servicio && formik.touched.servicio ? "1px solid red" : null }}
                />
              </CustomLabel>
            </div>
            <div>
              <CustomLabel htmlFor="empresaAdecco" className="col-form-label pt-0 w-100">
                Empresa Adecco
                <InputText
                  className="w-100"
                  type="text"
                  name="empresaAdecco"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={(empresaAdeccoValue && empresaAdeccoValue.label) || "Sin empresa Adecco"}
                  style={{ borderBottom: formik.errors.empresaAdecco && formik.touched.empresaAdecco ? "1px solid red" : null }}
                />
              </CustomLabel>
            </div>
            <div>
              <CustomLabel htmlFor="area" className="col-form-label pt-0 w-100">
                Área
                <InputText
                  className="w-100"
                  type="text"
                  name="area"
                  disabled
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={(areaValue && areaValue.label) || "Sin area"}
                  style={{ borderBottom: formik.errors.area && formik.touched.area ? "1px solid red" : null }}
                />
              </CustomLabel>
            </div>
            <div>
              <div className="mb-3">
                <CustomLabel htmlFor="cargo" className="col-form-label pt-0 w-100">
                  Cargo
                  <InputText
                    className="w-100"
                    type="text"
                    name="cargo"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.cargo}
                    style={{ borderBottom: formik.errors.cargo && formik.touched.cargo ? "1px solid red" : null }}
                  />
                </CustomLabel>
                {formik.errors.cargo && formik.touched.cargo && (
                  <CustomLabel style={{ color: "red" }} className="input-feedback">
                    {formik.errors.cargo}
                  </CustomLabel>
                )}
              </div>
            </div>
            <div>
              <div className="mb-3">
                <CustomLabel htmlFor="vacantes" className="col-form-label pt-0 w-100">
                  Vacantes
                  <InputText
                    className="w-100"
                    type="number"
                    pattern="[0-9]*"
                    name="vacantes"
                    disabled={formik.isSubmitting}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onWheel={(e) => e.target.blur()}
                    value={formik.values.vacantes}
                    style={{ borderBottom: formik.errors.vacantes && formik.touched.vacantes ? "1px solid red" : null }}
                  />
                </CustomLabel>
                {formik.errors.vacantes && formik.touched.vacantes && (
                  <CustomLabel style={{ color: "red" }} className="input-feedback">
                    {formik.errors.vacantes}
                  </CustomLabel>
                )}
              </div>
            </div>
          </GridGroup>

          <TemplateHeader className="mb-3" />

          <GridGroup className="mb-4">
            <div>
              <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                {preventiva ? "Fecha preventiva" : "Fecha de apertura"}
              </CustomLabel>
              {preventiva ? (
                <StylesDatePicker className="mb-1">
                  <DatePicker
                    locale={locale}
                    className="digits date-input"
                    dateFormat="AAAA-MM-dd"
                    onChange={handlePreventiveDateChange}
                    disabled={formik.isSubmitting}
                    value={formatearFecha(fechaPreventivaValue)}
                    selected={fechaPreventivaValue ? new Date(fechaPreventivaValue).setDate(new Date(fechaPreventivaValue).getDate() + 1) : null}
                    maxDate={new Date()}
                  />
                  {messageError.fechaObjetivoCobertura && formik.touched.fechaObjetivoCobertura && (
                    <div className="input-feedback">{messageError.fechaObjetivoCobertura}</div>
                  )}
                </StylesDatePicker>
              ) : (
                <StylesDatePicker className="mb-1">
                  <DatePicker
                    locale={locale}
                    className="digits date-input"
                    dateFormat="AAAA-MM-dd"
                    onChange={handleDatesChange}
                    disabled={formik.isSubmitting || preventiva}
                    value={formatearFecha(fechaAbiertaValue)}
                    selected={fechaAbiertaValue ? new Date(fechaAbiertaValue).setDate(new Date(fechaAbiertaValue).getDate() + 1) : null}
                    maxDate={new Date()}
                    minDate={new Date(new Date().setDate(new Date().getDate() - 2))}
                  />
                  {messageError.fechaAbierta && formik.touched.fechaAbierta && <div className="input-feedback">{messageError.fechaAbierta}</div>}
                </StylesDatePicker>
              )}
            </div>
            {servicioValue && servicioValue.value !== 1 && (
              <div className="d-flex align-items-center align-self-end">
                <InputCheckboxContainer className="d-flex align-items-center">
                  <div className="checkbox-wrapper-19">
                    <input
                      type="checkbox"
                      id="preventiva"
                      name="preventiva"
                      onChange={() => {
                        setPreventiva(!preventiva);
                      }}
                      checked={preventiva}
                    />
                    <label htmlFor="preventiva" className="check-box m-0" />
                  </div>
                </InputCheckboxContainer>
                <CustomLabel style={{ fontSize: "14px" }} className="ml-2">
                  Base Preventiva
                </CustomLabel>
              </div>
            )}
          </GridGroup>
        </div>
        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button color="btn-secondary mr-2" onClick={() => setConfirmModal(!confirmModal)}>
            Cancelar
          </Button>
          <ButtonPrimary isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="submit">
            Crear Nota de Pedido
          </ButtonPrimary>
        </div>
        <div>
          <Modal isOpen={confirmModal} centered size="sm" style={{ fontFamily: "Nunito" }}>
            <ModalBody>
              <p className="text-center mt-3">Estas a punto de cancelar esta nota de pedido. ¿Deseas continuar?</p>
              <div className=" mt-3 mb-0 d-flex justify-content-end">
                <Button color="btn-secondary mr-2" onClick={() => setConfirmModal(!confirmModal)}>
                  No
                </Button>
                <ButtonPrimary style={{ width: "70px", justifyContent: "center" }} onClick={handleCancelarNota}>
                  Si
                </ButtonPrimary>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </form>
    </>
  );
};

export default FormNuevaNP;
